import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'letter-m-small', 'IconLetterMSmall', [["path",{"d":"M9 16v-8l3 5l3 -5v8","key":"svg-0"}]]);